import { TransformComponent, TransformWrapper, useControls } from 'react-zoom-pan-pinch';
import { useEffect } from 'react';
import map from '../../assets/mkworld-assets/worldmap.webp'
import track_list from '../../assets/asset_loaders/tracks';
import RoadPattern from './RoadPattern';
import './Map.css';

export default Map;

function Map({ selectedTrack, highlightedConnectionId, clickTrackIcon, onResetZoom }) {

    const Controls = () => {
        const { zoomIn, zoomOut, setTransform, resetTransform } = useControls();

        useEffect(() => {
            if (selectedTrack) {
                const track = track_list.find(t => t.id === selectedTrack.id);
                if (track) {
                    // Get the actual map container to determine viewport
                    const mapContainer = document.querySelector('.map-container');
                    const mapImage = document.querySelector('.map-image');
                    if (!mapImage || !mapContainer) return;
                    
                    const mapWidth = mapImage.clientWidth;
                    const mapHeight = mapImage.clientHeight;
                    
                    // Calculate center position based on track percentage
                    const centerX = (track.pos.x / 100) * mapWidth;
                    const centerY = (track.pos.y / 100) * mapHeight;
                    
                    // Determine zoom level based on screen size (dynamic scaling)
                    const screenWidth = window.innerWidth;
                    const isMobile = screenWidth <= 768;
                    
                    // Dynamic zoom: smaller screens get less zoom to see more context
                    let zoomLevel;
                    if (isMobile) {
                        // Scale from 1.2 (320px) to 1.5 (768px)
                        zoomLevel = 1.2 + ((screenWidth - 320) / (768 - 320)) * 0.3;
                    } else {
                        zoomLevel = 1.25;
                    }
                    
                    // Get container dimensions
                    const containerWidth = mapContainer.clientWidth;
                    const containerHeight = mapContainer.clientHeight;
                    
                    // Calculate position to center the track in the container
                    const positionX = -centerX * zoomLevel + containerWidth / 2;
                    const positionY = -centerY * zoomLevel + containerHeight / 2;
                    
                    // Apply bounds checking
                    const scaledWidth = mapWidth * zoomLevel;
                    const scaledHeight = mapHeight * zoomLevel;
                    
                    const maxX = 0;
                    const minX = containerWidth - scaledWidth;
                    const maxY = 0;
                    const minY = containerHeight - scaledHeight;
                    
                    const boundedX = Math.max(minX, Math.min(maxX, positionX));
                    const boundedY = Math.max(minY, Math.min(maxY, positionY));
                    
                    setTimeout(() => {
                        setTransform(boundedX, boundedY, zoomLevel, 300);
                    }, 100);
                }
            } else {
                // Reset zoom when no track is selected
                setTimeout(() => {
                    resetTransform(300);
                }, 100);
            }
        }, [setTransform, resetTransform]);

        return <div className="map-controls">
            <button className="map-control-button" onClick={() => zoomIn()}>+</button>
            <button className="map-control-button" onClick={() => zoomOut()}>-</button>
            <button 
                className="map-control-button map-reset-zoom" 
                onClick={() => resetTransform(300)}
                style={{ display: 'none' }}
            >
                ⟲
            </button>
        </div>

    }

    const handleTrackClick = (id) => {
        clickTrackIcon(id);
    }

    return <div className="map-container">
        <TransformWrapper
            limitToBounds={true}
            initialScale={1}
            disablePadding={false}
            minScale={1}
            maxScale={2.5}
            wheel={{ step: 0.2 }}
            doubleClick={{ mode: 'toggle' }}
            centerOnInit={true}
        >
            <Controls />

            <TransformComponent>
                <div className="map-relative-container">
                    <img src={map} alt='Mario Kart World Map' className="map-image" />

                    <RoadPattern selectedTrack={selectedTrack} highlightedConnectionId={highlightedConnectionId} />

                    {
                        track_list.map((track) => {
                            return <MapIcon
                                src={track.icon}
                                alt={track.name}
                                top={track.pos.y}
                                left={track.pos.x}
                                name={track.name}
                                id={track.id} // Pass id for click handler
                                key={track.id}
                                onClick={handleTrackClick} // Pass click handler
                                small={!(selectedTrack?.id === track.id || highlightedConnectionId === track.id) && selectedTrack !== null}
                            />;
                        })
                    }

                </div>
            </TransformComponent>
        </TransformWrapper>
    </div>

}

const MapIcon = ({ onClick, id, top, left, small, src, alt }) => {
    return <button
        onClick={() => onClick(id)} // Pass the track id to the handler
        className={`map-icon ${small ? 'small' : 'normal'}`}
        style={{
            top: `${top}%`,
            left: `${left}%`,
        }}
    >
        <img
            src={src}
            alt={alt}
        />
    </button>;
}